import { ITenantConfig } from 'data/tenant-config';

export interface IClaimFilters {
  brands: string[];
  markets: string[];
}

/**
 * Filter tenant configurations by user claims.
 *
 * - An empty `brands` array means "no brand restriction" (all brands pass).
 * - An empty `markets` array means "no market restriction" (all markets pass).
 * - When both are non-empty, the result is the intersection: configs must
 *   match an allowed brand AND an allowed market.
 *
 * Returns a new array; the input is never mutated.
 */
export function filterConfigsByClaims(configs: ITenantConfig[], { brands, markets }: IClaimFilters): ITenantConfig[] {
  return configs.filter((config) => {
    if (brands.length > 0 && !brands.includes(config.brand)) return false;
    if (markets.length > 0 && !markets.includes(config.market)) return false;
    return true;
  });
}
